const pieColors = {
    inactive: '#808080',
    active: '#004d00',
    completed: '#33cc33',
    canceled: '#cc0000',
};

export default pieColors;
